var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_13562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 8.00004C7.26602 8.00004 6.66602 7.40004 6.66602 6.66671C6.66602 5.93337 7.26602 5.33337 7.99935 5.33337C8.73268 5.33337 9.33268 5.93337 9.33268 6.66671C9.33268 7.40004 8.73268 8.00004 7.99935 8.00004ZM11.9993 6.80004C11.9993 4.38004 10.2327 2.66671 7.99935 2.66671C5.76602 2.66671 3.99935 4.38004 3.99935 6.80004C3.99935 8.36004 5.29935 10.4267 7.99935 12.8934C10.6993 10.4267 11.9993 8.36004 11.9993 6.80004ZM7.99935 1.33337C10.7993 1.33337 13.3327 3.48004 13.3327 6.80004C13.3327 9.01337 11.5527 11.6334 7.99935 14.6667C4.44602 11.6334 2.66602 9.01337 2.66602 6.80004C2.66602 3.48004 5.19935 1.33337 7.99935 1.33337Z",
    fill: "#312E40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_13562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.17913e22e9f6e247699f492bc8e38651.svg";
export { ForwardRef as ReactComponent };